import React from 'react';

import { BREAKPOINTS, unit } from '@zego/theme';

import ContentContainer from '@zego/components/ContentContainer';
import StaticBackgroundImage from '@zego/components/StaticBackgroundImage';

const Hero = ({ children, image, promo, bgBlend }) => (
  <StaticBackgroundImage
    src={image}
    ratios={[1 / 4, 1 / 3, 1 / 2, 2 / 3, 1, 3 / 2, 2, 3.11]}
    css={{
      // All use of !important is needed here as "inline" .style applied in FluidBackgroundImageBase
      position: 'relative',
      marginTop: -100,
      backgroundSize: 'auto!important',
      [BREAKPOINTS.medium]: {
        backgroundSize: 'cover!important',
      },
      [BREAKPOINTS.normal]: {
        marginTop: -(50 + 100),
        backgroundPosition: 'top!important',
      },
    }}
  >
    <div
      css={{
        backgroundColor: bgBlend,
        height: '100%',
        paddingTop: 100,
        [BREAKPOINTS.normal]: {
          paddingTop: 50 + 100,
        },
      }}
    >
      {promo}
      <ContentContainer
        css={{
          paddingTop: unit(1),
          paddingBottom: unit(1),
        }}
      >
        {children}
      </ContentContainer>
    </div>
  </StaticBackgroundImage>
);

export default Hero;
